<div class="list-header">
  <div class="row py-2 align-items-center">
    <div class="col-4">
      <button
        class="mat-button leftBtn mx-3"
        mat-fab
        extended
        *ngIf="leftButtonCondition"
        type="button"
        (click)="leftBtnClickEvent()"
      >
        <mat-icon>{{leftButtonIcon}}</mat-icon>
        {{leftButtonLabel}}
      </button>
    </div>
    <div class="col-4">
      <h3 class="pt-2">{{centerLabel}}</h3>
    </div>
    <div class="col-4 text-right">
      <button class="mat-button rightBtn mx-3" mat-border-radius="5px" mat-fab extended *ngIf="rightButtonCondition" (click)="rightBtnClickEvent()">
        <mat-icon>{{rightButtonIcon}}</mat-icon>
        {{rightButtonLabel}}
      </button>
    </div>
  </div>
</div>
<div class="list-body">
  <ng-content></ng-content>
</div>